import { EMPTY_OBJECT } from '../../constants/common'
import { BIRDVIEW_SECTION_ITEMS_LIMIT } from '../../constants/dashboard'

import {
  BIRDVIEW_REQUEST_KEY_SEPARATOR,
  BirdviewState,
  EMPTY_SECTION,
} from './DashboardBirdview.constants'

function checkIsBirdviewFirstLoad({ isLoading, isRefreshing }) {
  return isLoading && !isRefreshing
}

export function checkIsBirdviewNormalState(state) {
  return state === BirdviewState.Normal
}

export function checkIsBirdviewLoadingState(state) {
  return state === BirdviewState.Loading
}

export function checkIsBirdviewErrorState(state) {
  return state === BirdviewState.Error
}

export function checkIsBirdviewEmptyState(state) {
  return state === BirdviewState.Empty
}

export function checkIsBirdviewDashboardReload(sectionKey) {
  return !sectionKey
}

export function checkIsBirdviewTilesLoading(tiles) {
  return tiles.some(tile => checkIsBirdviewLoadingState(tile.state))
}

export function checkIsBirdviewSectionsLoading(sections) {
  return Object.values(sections).some(section => section.isLoading)
}

export function getBirdviewSectionState({
  hasError,
  isLoading,
  isRefreshing,
  items,
}) {
  if (hasError) {
    return BirdviewState.Error
  }

  if (checkIsBirdviewFirstLoad({ isLoading, isRefreshing })) {
    return BirdviewState.Loading
  }

  if (items.length === 0) {
    return BirdviewState.Empty
  }

  return BirdviewState.Normal
}

export function getBirdviewLoadState({ hasError, isLoading, isRefreshing }) {
  if (hasError) {
    return BirdviewState.Error
  }

  return checkIsBirdviewFirstLoad({ isLoading, isRefreshing })
    ? BirdviewState.Loading
    : BirdviewState.Normal
}

export function getBirdviewRequestKey(params, reloadToken) {
  return [...Object.values(params), reloadToken].join(
    BIRDVIEW_REQUEST_KEY_SEPARATOR
  )
}

// A section the dashboard never requested has no state at all.
export function getBirdviewSection(
  { data, hasError, isLoading, isRefreshing, reload } = EMPTY_OBJECT,
  itemsLimit = BIRDVIEW_SECTION_ITEMS_LIMIT
) {
  const section = data ?? EMPTY_SECTION
  const items = section.items.slice(0, itemsLimit)

  return {
    extra: section.extra,
    hasMore: section.total > items.length,
    isRefreshing,
    items,
    reload,
    state: getBirdviewSectionState({
      hasError,
      isLoading,
      isRefreshing,
      items,
    }),
    total: section.total,
  }
}

export function getBirdviewTiles({ definitions, section = EMPTY_OBJECT }) {
  const state = getBirdviewLoadState(section)

  return definitions.map(tile => ({
    ...tile,
    ...section.data?.[tile.key],
    isRefreshing: section.isRefreshing,
    state,
  }))
}
